import { default as ChevronLeftIconMUI } from '@mui/icons-material/ChevronLeft';

export const ChevronLeftIcon = ChevronLeftIconMUI;
